import { BCMSCurrency, useRoute } from "@bcm-dev/bcms-vite";
import { useActivityPageContext } from "compid/pages/ActivityPage";
import React from "react";

import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetHeaderView from "compid/shared/containers/WidgetContainer/views/WidgetHeaderView";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import { SVGAsset } from "res";

/**
 * @function EditableActivityView
 * @returns {React.Component}
 * @description Shows all payments that are able to be modified
 * @exported true
 * @example
 * <EditableActivityView />
 */
export default function EditableActivityView(props) {
    // Call the useRoute hook and create the onClick event to occur when the edit button is clicked
    const navigate = useRoute();
    const viewPayment = id => () => navigate(`/viewPayment/${ id }`);
    // Grab state from the page context and determine if the state is an intance of the biller model class
    const { filtered } = useActivityPageContext();
    const payments = filtered.filter(payment => payment.status.toLowerCase() === "scheduled", []);
        
    // Map over all payments creating a BillerView component for each
    const paymentItems = payments.map(payment => {
        return (
            <BillerView 
                key={ "payment_" + payment.id }
                biller={ payment.to }
                dataPoint={ `Activity_Scheduled_Biller_${ payment.id }` }
                paymentInfo={
                    <BillerPaymentView 
                        amount={ payment.amount }
                        status={ payment.status }
                        date={ payment.formatDate }
                        showAutopay={ payment.hasRelatedAutopay } />
                }
                buttons={
                    <ButtonContainer className="set-width">
                        <SVGAsset id="RightChevronIcon" className="clickable mobile-chevron" onClick={ viewPayment(payment.id) } data-point={ `Activity_Scheduled_Chevron_${ payment.id }` } />
                    </ButtonContainer>
                } />
        );
    }, []);
    // Calcuate the total amount based on the payments
    const totalAmount = payments.reduce((result, payment) => result + parseFloat(payment.amount.amount), 0);
    // If there are no payment items then this component should be hidden
    const shouldShowNoBills = paymentItems.length === 0;

    return (
        <WidgetContainer>
            {/*<StickyWidgetHeaderView>*/}
                <WidgetHeaderView title={
                        <div className="flex-container flex-horizontal align-center">
                            <span data-point="Activity_Scheduled_Title">Scheduled</span>   
                        </div>
                    } dataPoint="Activity_Scheduled_Header">
                    
                    <p className="bold-text">Total: { BCMSCurrency.toCurrency(totalAmount) }</p>
                    
                    <span className="tooltip">
                        <SVGAsset id="InfoIcon" className="right-icon header-icon" />

                        <span className="tooltip-text">
                            The total reflects sum of scheduled payments, including any applicable fees.
                        </span>
                    </span>
                </WidgetHeaderView>
            {/*</StickyWidgetHeaderView>*/}

            { !shouldShowNoBills ? paymentItems : <EditableNoBillsView /> }
        </WidgetContainer>
    );
}

function EditableNoBillsView(props) {
    return (
        <div className="row-container">
            <div className="flex-container flex-horizontal align-center row-main-content">
                <SVGAsset id="UpsellIcon" className="show-on-desktop blue-icon logo set-width logo-container" />
                <SVGAsset id="UpsellIcon" className="logo set-width logo-container show-on-mobile" />

                <div className="flex-width">
                    <span>No scheduled bills found</span>
                </div>
            </div>
        </div>
    );
}